import { render, staticRenderFns } from "./ParticaArticleWritten.vue?vue&type=template&id=851cac30&scoped=true&"
import script from "./ParticaArticleWritten.vue?vue&type=script&lang=ts&"
export * from "./ParticaArticleWritten.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaArticleWritten.vue?vue&type=style&index=0&id=851cac30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851cac30",
  null
  
)

export default component.exports